import React, { forwardRef, useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import classes from './style.module.css';
import { icons } from '../../../../shared/icons';
import PropTypes from 'prop-types';
import { toast } from 'react-hot-toast';
import MyButton from '../myButton/MyButton';
import ProgressBar from './ProgressBar'; // Import the new ProgressBar component
import { useTranslation } from 'react-i18next';
import useHttp from '../../../hooks/use-http';
import PregledSlikaPopupUniverzalno from '../PregledSlika/PregledSlikaPopupUniverzalno';

const DragAndDrop = forwardRef(
  (
    {
      handleFiles,
      accept,
      maxFiles,
      addedFiles = [],
      handleRemoveFile = () => {},
      enableAddFiles = true,
      enableDelete = true,
      enableCustomDownload = false,
      customDownload,
      showBtnOnlyAdmin,
      title = 'titles.clickToUpload',
      showPreview = false,
    },
    ref,
  ) => {
    const { t } = useTranslation();
    const [selectedImg, setSelectedImg] = useState('');
    const { getData } = useHttp('');
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [localFiles, setLocalFiles] = useState([]);

    const onDrop = useCallback(
      (acceptedFiles) => {
        const totalFiles = localFiles.length + acceptedFiles.length;
        if (totalFiles > maxFiles) {
          toast.error(`Dozvoljeno je maksimalno ${maxFiles} fajlova.`);
          setUploading(false);
          return;
        }

        setUploading(true);
        setProgress(0);

        let uploadProgress = 0;
        const interval = setInterval(() => {
          uploadProgress += 10;
          setProgress(uploadProgress);
          if (uploadProgress >= 100) {
            clearInterval(interval);
            setUploading(false);

            const combined = [...localFiles, ...acceptedFiles];
            const uniqueFiles = Array.from(
              new Map(combined.map((f) => [f.name, f])).values(),
            );

            setLocalFiles(uniqueFiles);
            handleFiles(uniqueFiles);
          }
        }, 100);
      },
      [handleFiles, localFiles, maxFiles],
    );

    const { getRootProps, getInputProps, acceptedFiles, fileRejections } =
      useDropzone({
        onDrop,
        accept: accept,
        maxFiles: maxFiles,
      });

    if (fileRejections.length > 0) {
      toast.error('Nije moguće uneti više od jednog fajla.');
    }

    const files = localFiles.map((file) => (
      <li key={file.path} style={{ listStyle: 'none' }}>
        {file.path} - {file.size} bytes
      </li>
    ));
    useEffect(() => {
      setLocalFiles(addedFiles);
    }, [addedFiles]);

    // const handleDownload = (file) => {
    //   const fileURL = URL.createObjectURL(
    //     new Blob([file], { type: file.type }),
    //   );
    //   const link = document.createElement('a');
    //   link.href = fileURL;
    //   link.setAttribute('download', file.name);
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // };
    const downloadFile = async (fileUrl, fileName) => {
      const config = {
        method: 'POST',
        url: 'Dokumenta/konvertovanje_base64',
        data: { vrednost: fileUrl },
      };

      const response = await getData(config);

      const base64Data = response; // Pretpostavljam da response.data sadrži base64 string.

      // Konvertovanje base64 stringa u Blob objekt
      const byteCharacters = atob(base64Data);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0),
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/octet-stream' });

      // Kreiranje URL-a za Blob objekt
      const blobUrl = URL.createObjectURL(blob);

      // Kreiranje i klikanje na link element za preuzimanje datoteke
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', fileName); // Postavite naziv datoteke
      document.body.appendChild(link);
      link.click();

      // Čišćenje URL-a i uklanjanje linka
      URL.revokeObjectURL(blobUrl);
      document.body.removeChild(link);
    };
    const isImageFile = (file) => {
      if (!file?.name) return false;

      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
      const extension = file.name.split('.').pop().toLowerCase();

      return imageExtensions.includes(extension);
    };
    const previewImage = (item) => {
      setSelectedImg(item.url);
    };
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        {uploading && <ProgressBar progress={progress} />}{' '}
        {/* Use ProgressBar component */}
        {enableAddFiles && (
          <div {...getRootProps({ ref })} className={classes.container}>
            <input {...getInputProps()} />
            {files.length === 0 && (
              <>
                <span className={classes.spanClick}>{t(title)}:</span>
                <div className={classes.upLogo}>{icons.UPLOAD_ICON}</div>
              </>
            )}
            {files.length > 0 && (
              <span className={classes.spanClick}>Postavljeni fajlovi:</span>
            )}
            <span>{files}</span>
          </div>
        )}
        {addedFiles.length !== 0 && (
          <div className={classes.container}>
            <div
              style={{
                border: '1px solid gray',
                marginTop: '10px',
                padding: '5px',
                width: '100%',
              }}
            >
              <span
                style={{
                  marginBottom: '0px',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: 'black',
                }}
              >
                Dodat fajl
              </span>
              {addedFiles.map((item) => (
                <div className={classes.fileRow} key={item.name}>
                  <span
                    style={{
                      display: 'inline-block',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      // maxWidth: '150px',
                    }}
                  >
                    {item.name !== null && item.name !== '' && item.name}
                  </span>{' '}
                  <div>
                    {enableDelete && !showBtnOnlyAdmin && (
                      <MyButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveFile(item);
                        }}
                        icon="fas fa-trash"
                        style={{
                          height: '25px',
                          width: '25px',
                          padding: '0px',
                          textAlign: 'center',
                        }}
                        iconStyle={{ margin: '0px' }}
                      />
                    )}
                    {!enableCustomDownload && (
                      <MyButton
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadFile(item.path, item.name);
                        }}
                        icon="fas fa-download"
                        style={{
                          height: '25px',
                          width: '25px',
                          padding: '0px',
                          textAlign: 'center',
                        }}
                        iconStyle={{ margin: '0px' }}
                      />
                    )}
                    {enableCustomDownload && (
                      <MyButton
                        onClick={(e) => {
                          e.stopPropagation();
                          customDownload(item);
                        }}
                        icon="fas fa-download"
                        style={{
                          height: '25px',
                          width: '25px',
                          padding: '0px',
                          textAlign: 'center',
                        }}
                        iconStyle={{ margin: '0px' }}
                      />
                    )}
                    {showPreview && isImageFile(item) && (
                      <MyButton
                        onClick={(e) => {
                          e.stopPropagation();
                          previewImage(item);
                        }}
                        icon="fas fa-eye"
                        style={{
                          height: '25px',
                          width: '25px',
                          padding: '0px',
                          textAlign: 'center',
                          marginRight: '5px',
                        }}
                        iconStyle={{ margin: '0px' }}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {selectedImg && (
          <PregledSlikaPopupUniverzalno
            selectedImg={selectedImg}
            setSelectedImg={setSelectedImg}
          />
        )}
      </div>
    );
  },
);

DragAndDrop.propTypes = {
  handleFiles: PropTypes.func.isRequired,
  accept: PropTypes.object,
  maxFiles: PropTypes.number.isRequired,
};

export default DragAndDrop;
